<template>
    <div class="forgetbg">
        <div class="header">
            <div class="logo clearfix">
                <img class="logoimg " src="@static/images/logo.png" alt="">
                <div class="logoword">
                    <span class="bfont">凤栖云服</span><br/>
                    保险连接服务平台
                </div>
            </div>
        </div>
        <el-card class="from-card">
            <div class="line">
                <span>基本信息</span>
            </div>
            <el-steps  :active='active' :space='300'  finish-status="success"  align-center>
                <el-step title="确认账户"></el-step>
                <el-step title="重置账户"></el-step>
                <el-step title="重置完成"></el-step>
            </el-steps>
            <el-form  class="fform"   ref="loginform"  :label-position='labelPosition' label-width="90px">
                <template v-if="active==0">
                    <el-form-item label="手机号" prop="pass">
                        <el-input type="text" ></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="pass">
                        <el-input type="text" class="code"><el-button class="codebtn" slot='append'>获取验证码</el-button></el-input>
                    </el-form-item>
                </template>
                <template v-if="active==1">
                    <el-form-item label="新密码" prop="pass">
                        <el-input type="password" show-password ></el-input>
                    </el-form-item>
                    <el-form-item label="确认新密码" prop="pass">
                        <el-input type="password" show-password class="code"></el-input>
                    </el-form-item>
                </template>
                <template v-if="active==3">
                    <div class="success">
                        <img src="@static/images/success1.png" alt="">
                        <p class="zhu">重置成功</p>
                        <p class="fu">你可以使用新的密码进行登录</p>
                    </div>
                </template>
                <el-button class="btn" v-if="active==0" @click="frist">下一步</el-button>
                <el-button class="btn" v-if="active==1" @click="two">下一步</el-button>
                <el-button class="btn" v-if="active==3" @click="gologin">登录</el-button>
            </el-form>
        </el-card>
    </div>
</template>
<script>
    //当前实例组件
    export default {
        data: () => ({
            labelPosition: 'left',
            region: '',
            active: 0
        }),
        components: {},
        created() {},
        methods: {
            frist: function() {
                this.active += 1
            },
            two: function() {
                this.active += 2
            }
        },
        mounted() {
        }
    };
</script>
<style lang="scss">
    @import "~@/sass/pages/forget";
</style>
